export default {
  lang: '语言',
  t1: '您的浏览器不支持自动播放视频。',
  t2: '四十有为 卓越吾乡',
  t3: '城市传奇',
  t4: '致敬经典',
  t5: '新闻动态',
  t6: '投关资讯',
  t7: '美好生活领创者',
  t8: '探索更多',
  t9: '至真 致美 置吾乡',
  t10: '股份代号',
  t11: '保利置业集团有限公司',
  t12: '最新公告',
  t13: '隐私说明',
  t14: '法律声明',
  t15: '保利置业',
  t16: '可持续发展',
  t17: '多元业务',
  t18: '商旅服务',
  t19: '房地产开发',
  t20: '物业服务',
  t21: '科技创新',
  t22: '保利待客之道',
  t23: '缔造吾乡归家之感',
  t24: '全国布局',
  t25: '个城市',
  t26: '个项目',
  t27: '服务',
  t28: '联系我们',
  t29: '保利置业集团',
  t30: '地址：香港夏慤道18号海富中心第一期2503室',
  t31: '香港',
  t32: '电话',
  t33: '传真',
  t34: '电邮',
  t35: '地址',
  t36: '心安吾乡',
  t37: '保利置业香港股票代码',
  t38: '保利置业集团有限公司(00119.HK)，简称保利置业，总部设在香港和上海，于香港联交所主板上市，公司控股股东为保利(香港)控股有限公司，前身为成立于1985年的嵘高贸易有限公司。作为中国保利集团地产主业的重要柱石、资本市场的重要平台和海外布局的重要窗口，保利置业已形成以境内外高端房地产开发、城市综合投资运营、城市美好生活服务、科技创新为主要业务板块，以集团优质产业资源融合为支撑的「两轮、双翼、多元驱动」发展战略。',
  t39: '保利置业房开平台业务涉及房地产投资开发、销售、自持物业运营管理，分布在香港、上海、江苏、浙江、广东、深圳等11个区域、30多个城市，在建拟建项目过百。保利物业管理项目业态涉及住宅、商业、写字楼、综合体、销售案场、公服等，分布在上海、江苏、浙江等11个区域41个城市，签约项目超过300个，签约面积达到6000万平方米。酒店管理业务除拥有自营品牌酒店外，分别与洲际酒店（IHG）、凯悦酒店（Hyatt）等国际知名酒店管理集团合作，经营四星、五星酒店十余家。',
  t40: '业务布局',
  t41: '中国保利集团以多元业态扎根核心战略城市群，业务遍及国内百余个城市，与全球',
  t42: '多个国家和地区保持密切业务往来，目前共有',
  t43: '多家境外机构进驻全球',
  t44: '个国家和地区，形成了覆盖全球的营销网络和业务支点，有力支撑中国保利集团业务拓展。',
  t45: '进入新发展阶段，中国保利集团围绕“建设一流、追求卓越”战略目标，以习近平新时代中国特色社会主义为指导，完整、准确、全面贯彻新发展理念，融入和构建新发展格局，增强“四个意识”、坚定“四个自信”、做到“两个维护”，牢记“国之大者”，充分发挥国有资本投资公司功能作用，践行服务国家产业布局和结构优化的使命，加强“管资本”能力建设，以改革创新为动力，以风险防控为关键，以精益管理为抓手，进一步增强竞争力、创新力、控制力、影响力和抗风险能力，打造形成具有国际竞争力、国内领先的“5+1”业务体系，为广大人民群众提供“高端、高质、高品”的产品和服务，满足人民对高品质美好生活的向往，以优秀业绩回馈股东、客户、社会、国家，为打造保利百年老店，实现基业长青而不懈奋斗！',
  t46: '目前，中国保利集团拥有11家主要子公司，职工10万人，境内外控股上市公司5家，分别为：保利发展控股集团股份有限公司（股票代码：S.H.600048）、保利置业集团有限公司（股票代码：H.K.00119）、中国海诚工程科技股份有限公司（股票代码：S.Z.002116）、保利联合化工控股集团股份有限公司（股票代码：S.Z.002037）、保利物业服务股份有限公司（股票代码：H.K.06049）。',
  t47: '中国保利集团有限公司（以下简称“中国保利集团”或“集团”）是经国务院、中央军委批准组建，由国务院国有资产监督管理委员会直接管理的大型中央企业。成立40年来，保利已形成“优化贸易、升级地产、做强文化、创新科技、做特工程、金融支撑”的“5+1”业务体系，成为业务范围涵盖衣食住行用和精神文化生活等方面的多元化企业集团，业务遍布国内100多个城市及全球近百个国家。中国保利集团位列2024年《财富》世界500强第173位，13次获国务院国资委业绩考核A级。',
  t48: '中国保利集团有限公司',
  t49: '亿元',
  t50: '品牌价值位居综合服务领域榜首',
  t51: '中央企业品牌建设榜单位列第',
  t52: '位',
  t53: '中国保利',
  t54: '我们重视业务往来过程中的公正廉洁承诺与审查，持续推进阳光采购工程。供应商必须提供《廉洁合作承诺》作为入库呈批必要附件；在合同签约阶段，双方须签署《廉洁合作协议》《保利置业营销采购招标阳光宣言》，作为合同必要附件。秉持着「依法依规、预防为主、公平公正、公开透明」的原则，我们根据《中国保利集团有限公司供应商廉洁黑名单管理办法》，建立供应商廉洁黑名单管理，对黑名单内的供应商施行「一处违规、处处受限」联合惩戒机制，完善供应商廉洁管理及监督体系，规范供应商廉洁从业行为。',
  t55: '作为中国保利集团地产主业的重要柱石、资本市场的重要平台和海外布局的重要窗口，保利置业已形成以境内外高端房地产开发、城市综合投资运营、城市美好生活服务、科技创新为主要业务板块，以集团优质产业资源融合为支撑的“两轮、双翼、多元驱动”发展战略。',
  t56: '保利置业卓越发展战略',
  t57: `两轮 双翼 多元驱动`,
  t58: `遵循中国保利集团“保国利民
              追求卓越”使命，保利置业多年秉承高度社会责任感，践行央企担当。翻开时光履历，自2021年起，保利置业发起“保利少年志”公益行动，以志为核，现已覆盖全国13大区域、30多座城市，累计助力万余中国青少年筑梦圆梦。`,
  t59: `助力中国儿童美学教育和理想启蒙`,
  t60: `2021年，保利置业发起大型公益行动“保利少年志”，助力中国儿童美学教育和理想启蒙。近年来，保利置业承担了贵州、广西、海南等多个地区定点帮扶，累计投入帮扶资金6000多万，彰显了央企责任和家国情怀。;`,
  t61: `2021年，保利置业发起大型公益行动“保利少年志”，助力中国儿童美学教育和理想启蒙。近年来，保利置业承担了贵州、广西、海南等多个地区定点帮扶，累计投入帮扶资金6000多万，彰显了央企责任和家国情怀。;`,
  t62: `2000年5月，保利在香港积极参与抢救流失海外的祖国珍贵文物，相继迎回猴首、牛首和虎首，漂泊海外140年的国宝兽首，终于回到阔别已久的故乡。此后，港澳企业家何鸿燊博士捐赠了猪首。如今，四座圆明园兽首相聚在保利艺术博物馆，它们失而复得的经历，刻画着一个世纪跌宕起伏的历史沧桑，也书写着一个民族的复兴历程与家国情怀。;`,
  t63: `1999年，中国数字技术产业端倪初现，保利星在北京电子城工业园正式成立。24年来，保利星包揽了行业内所有国家级、省部级奖项，先后为行业制定国家标准3项、行业标准20项、团体标准1项，连续20年被认定为国家高新技术企业。2019年，保利星公司正式成立了以微流控生物芯片设计研发为主导的新公司——北京保利微芯科技有限公司，实现了技术密集型产业跨向知识密集型产业的赛道转换。;`,
  t64: `上海保利物业酒店管理集团有限公司 (以下简称保利物业)
                      于1996年12月在北京成立，隶属于保利置业集团，是首批国家一级资质物业管理企业，目前管理业务涉及住宅物业、商务写字楼、商业综合体、城市运营和景区公共服务等多元物业服务体系。;`,
  t65: `1993年1月，顺应时代的保利毅然投身浦东开发。中国保利集团在上海的第一个项目——上海证券大厦奠基仪式在沪举行，它见证了上海浦东乃至中国改革开放发展历程。同时期，参与投资、开发、建造广州中信广场，这是彼时中国内地最高的商业建筑，也是改革开放的标志性工程。;`,
  t66: `保利置业的诞生、成长与壮大，与国家战略发展紧密相连。1993年，中国保利集团完成香港上市公司新海康航业投资有限公司(H.K.
          00119) 55%的股权收购，实现在港主板上市。保利
          （香港）控股先后参与广州中信广场、北京新保利大厦等项目开发建设，布局香港龙誉、瑧誉、沄璟等多个行业标杆，累计在港创造数千个岗位，服务近千个家庭。;`,
  t67: `1992年，中国保利集团取得第一张涉外国有土地使用证（京中外国用（92）字第0001号）。这份土地证见证了丽京花园项目从筹建、选址、立项、施工，到销售、物业管理的每一个环节。作为北京市第一个涉外商品房项目，也是中国保利集团第一个房地产项目，在内地和香港两地同时销售的丽京花园，吸引大量华侨、港澳台同胞购买定居，创下了“4小时销售60套”的保利传奇。第一张涉外国有土地使用证，亲鉴一代代保利人进取的奋斗史，成为保利人奋进的精神力量。;`,
  t69: `2022年7月，保利商旅酒店管理有限公司（简称保利商旅酒店）正式成立，开启酒店轻资产业务运营模式。目前，保利商旅酒店管理业务除拥有自营品牌酒店外，分别与洲际酒店
          (IHG) 、凯悦酒店 (Hyatt)
          等国际知名酒店管理集团合作，在上海、北京、武汉、湖州、柳州、贵阳、顺德等城市的优质地段打造、经营四星、五星酒店九家。;`,
  t70: `2023年，保利置业登榜中指研究院“2023优秀房地产上市公司名单”，荣登“2023中国大陆在港上市房地产公司财富创造能力”、“2023中国大陆在港上市房地产公司财务稳健性”、“2023中国大陆在港上市房地产公司投资价值”、“2023中国房地产上市公司治理”四大榜单top10，收获了资本市场和行业的认可肯定，彰显保利置业良好发展态势和长远的发展潜力。;`,
  t71: `保利置业洞察时代与行业发展趋势，从客户需求出发，以“心安吾乡”为品牌主张，以人本主义为精神内核，以产品主义为硬核实力，以专业主义为重要抓手，始终坚持长期主义为发展导向，以“至真、致美、置吾乡”为客户宣言，通过产品、服务、文化、责任为四大品牌建设触点，提升市场化品牌影响力，以产品力、服务力、营销力、运营力、成本力(品质五力)为业务基石，打造具有卓越竞争力的品牌生态链，最终实现“保利是吾乡”品牌愿景，为广大客户和业主兑现美好期许。;`,

  t73: `发展历程`,
  t74: `品牌文化`,
  t75: `组织架构`,
  t76: `关于我们`,
  t77: `中国保利集团`,
  t78: `保利置业依托保利集围强大的资源协同支撑，实现产业全面升级，打造境内外高端房地开发、城市综合投资运营、城市美好生活服务、科技创新4大业务板块，形成“两轮、双翼、多元驱动”卓越发展战略：以境内外高端房地产开发和城市综合投资运营为“两轮”，通过两大核心业务的合理组合及良性发展，巩固行业领先地位；以城市美好生活服务和综合金融服务为“双翼”，塑造企业持续发展特色，助力业务发展；同时协同中国保利集团多项优质产业资源实现“多元驱动”，全面提升城市综合运营服务能力，实现企业高质量可持续发展。`,
  t79: `住宅开发`,
  t80: `住宅服务 商写服务 城市服务`,
  t81: `酒店 健身 商业`,
  t82: `保利微芯 保利星`,
  t83: `二零二四年十一月未经审核销售数据`,
  t84: `本站点（以下简称保利）非常重视对您的个人隐私保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私声明解释了这些情况下的数据收集和使用情况。`,
  t85: `本隐私声明适用于保利的所有相关服务，随着保利服务范围的扩大，隐私声明的内容可由保利随时更新，且毋须另行通知。更新后的隐私声明一旦在网页上公布即有效代替原来的隐私声明。`,
  t86: `我们收集哪些信息`,
  t87: `通常，您能在匿名的状态下访问保利并获取信息。当我们需要能识别您的个人信息或者可以与您联系的信息时，我们会征求您的同意。通常，在您注册保利或申请开通新的功能时，我们可能收集这些信息：姓名，Email地址，住址和电话号码，并征求您的确认。`,
  t88: `关于您的个人信息`,
  t89: `保利严格保护您个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄露。保利会在法律要求或符合保利的相关服务条款、软件许可使用协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：（a）满足法律或行政法规的明文规定，或者符合保利网站适用的法律程序；（b）符合保利相关服务条款、软件许可使用协议的约定；（c）保护保利的权利或财产，以及（d）在紧急情况下保护保利员工、保利产品或服务的用户或大众的个人安全。\n            保利不会未经您的允许将这些信息与第三方共享，本声明已经列出的上述情况除外。`,
  t90: `Cookie的使用`,
  t91: `使用Cookie能帮助您实现您的联机体验的个性化，您可以接受或拒绝Cookie，大多数Web浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie。`,
  t92: `保利有时会使用Cookie以便知道哪些网站受欢迎，使您在访问保利时能得到更好的服务。Cookie不会跟踪个人信息。当您注册保利时，保利亦会使用Cookie。在这种情况下，保利会收集并存储有用信息，当您再次访问保利时，我们可辨认您的身份。来自保利的Cookie只能被保利读取。`,
  t93: `如果您的浏览器被设置为拒绝Cookie，您仍然能够访问保利的大多数网页。`,
  t94: `关于免责说明`,
  t95: `就下列相关事宜的发生，保利不承担任何法律责任：`,
  t96: `*由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，或其他非因保利原因导致的个人信息的泄露；`,
  t97: `*保利根据法律规定或政府相关政策要求提供您的个人信息；`,
  t98: `*任何第三方根据保利各服务条款及声明中所列明的情况使用您的个人信息，由此所产生的纠纷；`,
  t99: `*任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性网站关闭；`,
  t100: `*因不可抗力导致的任何后果；`,
  t101: `*保利在各服务条款及声明中列明的使用方式或免责情形。\n            \n            本通知以中文撰写，并可能翻译成其它语言。如中文版本与翻译版本有任何歧异，概以中文版本为准。`,
  t102: `党的二十大报告提出：公益慈善力量在以中国式现代化全面推进中华民族伟大复兴中，有着不可替代的重要作用。遵循中国保利集团“保国利民\n            追求卓越”企业使命，保利置业多年来秉承高度的社会责任感和使命感，为建设社会主义文化强国积极贡献国资央企力量。`,
  t103: `保利少年志：赓续央企担当书写美好新答卷`,
  t104: `以志为核放飞少年梦想`,
  t105: `贡献“保利力量”`,
  t106: `2021年，保利置业带领9名大山少年飞跃大山，前往北京天安门、故宫、长城等地参观，捐建“保利艺术教室”“保利梦想图书室”并投入使用。2022年，开展“保利少年志·千里课堂”，全国11位梦想导师跋涉9300余公里，为66名大山孩子带来人文、艺术、理想启蒙课程。2023年，首次联动“保利星火教育金”，在全国7个定点帮扶县设置“保利少年志·星火教育金”，共捐赠210万元、覆盖1289名师生，夯实人才振兴、文化振兴的重要基石。`,
  t107: `三年成长、三年逐梦。保利少年志已打造成为具有社会影响力和品牌美誉度的公益品牌，先后在国企好新闻、中央企业品牌建设典型案例、中央企业优秀品牌故事、中央企业社会主义核心价值观主题微电影展映等评选中斩获荣誉，并入选《中央企业社会责任蓝皮书》。以“美好生活领创者”之姿，保利置业将持续以品牌建设，为加快实现中国现代化新征程贡献“保利力量”。`,
  t108: `保利少年志·公益资讯`,
  t109: `聚焦少年理想启蒙，实时传递公益动态`,
  t110: `让梦想发光，大山里的小梦想循光启航。`,
  t111: `千里课堂，翻越山丘，为少年种下梦想的种子。`,
  t112: `“保利星火教育金”走进河曲，为山区少年梦想助力。`,
  t113: `保利少年志·公益短片`,
  t114: `启迪少年成长之旅，讲述奋斗追梦故事`,
  t115: `保国利民 追求卓越`,
  t116: `点亮守护孩子的梦想之光，为大国崛起的未来聚力扛鼎`,
  t117: `保利少年志·公益光影`,
  t118: `记录少年奋斗足迹，定格追梦美好瞬间`,
  t119: `投资者关系`,
  t120: `业绩简报`,
  t121: `公司资料`,
  t122: `企业管治`,
  t123: `公告及通函`,
  t124: `年度/中期报告`,
  t125: `环境、社会及管治报告`,
  t126: `投资者通讯`,
  t128: `2024年中报`,
  t130: `以人为本`,
  t131: `精益管治`,
  t132: `美好生活`,
  t133: `绿色家园`,
  t134: `同享共创`,
  t135: `职业健康与安全`,
  t136: `员工管理`,
  t137: `保利置业建立健全职业健康与安全管理体系，加强员工安全培训，开展日常巡检和定期维护，并通过员工沟通、开展丰富多彩的员工关爱与帮扶活动，为员工创造安全无忧的工作环境。`,
  t138: `安全管理体系`,
  t139: `本集团遵循《中华人民共和国安全生产法》《中华人民共和国消防法》《中华人民共和国特种设备安全法》等职业健康和保障安全工作环境的相关法律法规，制定《保利置业安全生产监督管理办法》《保利置业安委会工作办法》《保利置业生产安全事故综合应急预案》等内部制度，全面推进安全生产及职业健康管理体系建设，确保风险持续受控、安全形势保持稳定。`,
  t140: `本集团制定年度安全管理标准化行动清单，成立安全管理委员会，各级负责人需按计划执行五项安全管理动作，包括年度培训、检查、隐患排查、应急演练和事故报告，并督导重大隐患整治等任务。分管负责人和安全管理部负责落实月度检查、会议、应急演练、档案管理和季度报告等管理动作。`,
  t141: `2023年，本集团全系统安全生产管理架构初步搭建完成，为安全管理体系高效运转提供有力的组织保证。保利物业、保利（香港）物业已通过ISO 45001 职业健康安全管理体系认证。`,
  t142: `安全文化建设`,
  t143: `2023年，本集团组织开展多种安全生产相关培训，包括安全应急演练、安全生产月、消防安全月等内容，全面提升员工职业健康与安全的专业能力，为健康安全工作有效落地奠定良好基础，持续夯实安全底线。`,
  t144: `应急演练活动`,
  t145: `开展多项应急演练活动，包括基坑坍塌、模板坍塌、脚手架坍塌、高处坠落、机械伤害、火灾、触电、中暑等事故或人员伤害等内容。参与演练员工深刻学习相关的安全生产知识，提高了员工安全生产意识以及事故急救技巧。`,
  t146: `4.15全民国家安全教育日`,
  t147: `开展4·15 全民国家安全教育日系列活动。通过开设线上学习专栏、办公区张贴国家安全宣传展板，组织观看国家安全宣传片，参观保密教育实训基地，开展网络安全知识测试和网络安全专项检查等融合互动形式，进一步增强员工安全意识。`,
  t148: `保利商旅「安全生产月」「消防安全月」`,
  t149: `培训活动内容涵盖规章制度、操作规程、技术标准规范等，通过培训，员工的安全防范意识得到提升，全年共开展164次安全生产培训，覆盖3,446人次。`,
  t150: `住宅小区防汛演习`,
  t151: `观看警示教育片`,
  t152: `保利商旅安全培训活动`,
  t153: `员工沟通`,
  t154: `本集团严格遵守《中华人民共和国工会法》《中国工会章程》《企业工会工作条例》《企业民主管理规定》相关要求，制定《保利置业集团有限公司加强工会工作实施办法》《保利置业集团有限公司厂务公开实施办法》等管理办法，完善职工代表大会制度，探索职工群众参与管理的有效方式。`,
  t155: `我们切实保障职工群众的知情权、参与权、表达权，提升企业民主管理发展的质量与效果。我们建立平等协商沟通渠道，通过谈心谈话、走访调研、座谈交流、在线意见征集、设置信访箱等渠道倾听员工声音，并于总部设立董事长信箱，进一步畅通职工群众沟通渠道。`,
  t156: `员工关爱`,
  t157: `本集团重视员工工作与生活平衡，建立并完善员工服务与关爱体系，组织多样化员工帮扶、文体活动，提高员工企业归属感，努力打造和谐、温暖、幸福的职场环境。`,
  t158: `2023 年，我们为困难职工申请保利爱心基金，帮扶员工9 人，共计完成发放补助款58,450 元。同时，我们开展金秋助学活动，助力职工子女就近入学。`,
  t159: `芳菲三月，美好如你\n花样活动共庆「三八」妇女节`,
  t160: `围绕「自尊、自信、自立、自强」的新时代女性精神，开展致敬「她力量」关心关爱女性职工主题宣传活动，各级工会组织花样主题活动，丰富女性职工业余文化生活，展现保利丽人热爱生活、昂扬向上的美好态度和卓越风采。`,
  t161: `採春品茗 夏雅的你最美活动`,
  t162: `「保」持热爱 全「利」以赴\n2023 年长三角地区趣味运动会`,
  t163: `举办2023年长三角地区趣味运动会。本次运动会作为「保利是吾乡」企业文化建设行动的重要环节，不仅加强干部与员工之间的交流，更加强了企业凝聚力、振奋了精神、增进了友谊，展现出保利置业人奋发进取、昂扬向上的精神风貌。`,
  t164: `2023年长三角地区趣味运动会`,
  t165: `工会兴趣小组`,
  t166: `本集团工会成立多个兴趣小组，培育健康文明、积极向上的职工文化，兴趣小组涵盖瑜伽、羽毛球、篮球、足球等。各区域也成立游泳、绘画、茶艺等职工文体小组，并组织各类文体活动，如乐跑、篮球友谊赛、羽毛球赛等，共同打造有温度的「保利家园」。`,
  t167: `工会兴趣小组`,
  t168: `保利置业秉持「责任为本 发展至上」的核心价值观，致力于保障员工权益，提供健全薪酬福利体系，创造平等包容的职场环境。我们建立广阔的人才发展平台，定期开展丰富的活动为员工送去温暖与关怀，持续提升员工的幸福感与归属感。`,
  t169: `合规雇佣`,
  t170: `本集团严格遵守国家及各营运地的法律法规，建立并优化各项管理制度，规范在员工招聘雇佣方面的管理要求。`,
  t171: `本集团未发生过雇佣童工与强制劳工事件。`,
  t172: `我们遵守《中华人民共和国未成年人保护法》《禁止使用童工规定》等相关规定，要求下属所有企业不得招用童工，并通过建立规范严谨的招聘及日常员工管理制度避免招用童工。同时，我们依法禁止强制劳动行为，若发现疑似情况将立刻发起调查，如涉嫌构成强迫劳动罪，将进行依法处理。`,
  t173: `多元包容`,
  t174: `本集团秉承多元包容的原则，坚决杜绝在人员招聘及发展过程中出现任何因年龄、宗教信仰、国籍、婚姻状态、种族、肤色、民族、身体状况、性别认同等因素而产生的歧视行为。`,
  t175: `福利保障`,
  t176: `本集团遵守各项法律法规，严格执行国家及地方社会保障机制。我们通过制定科学完善的薪酬激励制度，为员工提供富有竞争力的薪资，保障人才的吸纳及留存，实现企业与员工的利益共享。对于相同工作、付出等量劳动且取得相同业绩的员工，我们承诺给予同等的劳动报酬及福利待遇。`,
  t177: `此外，我们为员工提供完善的福利保障，通过持续提升员工的福利待遇和优化关怀措施，让员工能够更加安心、舒适地投入到工作中。`,
  t178: `法定福利`,
  t179: `为员工缴纳养老、失业、医疗、工伤及生育保险，并缴纳住房公积金。`,
  t180: `根据经济效益情况安排为员工缴纳年金、补充公积金等。`,
  t181: `公司福利`,
  t182: `为员工提供就餐安排。`,
  t183: `为员工提供交通费、通讯费。`,
  t184: `发放节日费(如春节、元旦、端午、中秋等)。`,
  t185: `提供形式多样、内容丰富的员工活动。`,
  t186: `培训发展`,
  t187: `本集团致力于构建全方位的人才培养体系，为员工量身定制职业发展规划，建立清晰的职业发展路径。我们不断优化和完善覆盖人才发展全生命周期的管理体系，通过打造多元化成长发展平台，加强人才储备，提升人才专业化，实现企业与个人共同成长。`,
  t188: `中国保利集团-「以卓越向未来」新员工培训项目`,
  t189: `保利置业举办「以卓越向未来」新员工培训，帮助新员工加强对公司战略理解、管理要求掌握、文化理念认同、组织团队融入、廉洁意识强化，让新员工切身感受保利人的奋斗青春及「以匠心为城市创造经典地标」的追求，为公司可持续发展提供人才储备。`,
  t190: `新员工参观标杆项目`,
  t191: `浙江公司-「菁英计划」项目经理培训项目`,
  t192: `浙江公司开展「菁英计划」工作坊，围绕项目经理能力素质模型、项目经理素养提升、项目工程问题开展专项培训，以企业战略发展需要为出发点，强化项目经理队伍的核心竞争力。`,
  t193: `浙江公司2023年项目经理「菁英计划」`,
  t194: `山东公司-「领睿计划」中层管理培训项目`,
  t195: `山东公司组织开展中层管理者「领睿计划」培训，系统学习产品力提升、项目管理等相关课程，帮助核心人员掌握更为科学的管理逻辑、工具方法，在行业形势不断变化的情况下持续提升应变能力。`,
  t196: `山东公司「领睿计划」中层管理培训`,
  t197: `贵州公司-「管理素质提升赋能」培训项目`,
  t198: `贵州公司组织核心人员开展「管理素质提升赋能」培训，通过丰富多元的培训方式，加深管理者对人才管理知识及人才管理技能的理解，进一步提升管理人员综合管理素质。`,
  t199: `贵州公司管理素质提升赋能培训`,
  t204: `公告及通函`,
  t212: `年份`,
  t213: `全部`,
  t214: `公司经营通讯`,
  t215: `月度销售通讯`,
  t216: `业绩通讯`,
  t218: `ESG管治架构`,
  t219: `商业道德`,
  t220: `建立自董事会而下的管治架构`,
  t221: `ESG治理架构`,
  t222: `董事会`,
  t223: `作为公司ESG工作的最高领导和决策机构，负责审核及通过ESG工作战略、目标、政策及ESG报告，并检视公司年度ESG目标完成情况。`,
  t224: `董事会ESG委员会`,
  t225: `获董事会授权，履行ESG事宜的领导和监督职责，负责协助董事会监察公司的ESG工作战略、目标、政策及ESG报告，评估及厘定与公司业务相关的ESG重大风险，并直接向董事会汇报ESG工作。`,
  t226: `ESG工作领导小组`,
  t227: `由公司全体高级管理人员组成，负责拟定公司ESG工作战略、目标、政策，统筹ESG报告的编制工作，监督各职能中心和子公司的ESG目标落实和执行，并定期向董事会ESG委员会汇报工作及提供建议。`,
  t228: `ESG工作执行小组`,
  t229: `由全体职能中心和主要子公司负责人组成，负责落实领导小组下发的ESG政策和措施，参与编制公司ESG报告，及时向领导小组提供ESG工作建议及相关风险事件，定期汇报ESG工作进度，包括关键指标。`,
  t230: `双碳目标`,
  t231: `2030年努力实现经营性物业范围一及二单位面积碳排放强度降低20%以上（以2023年为基准），争取2060年实现碳中和。`,
  t232: `我们承诺，100% 的新获取项目至少按照中国绿色建筑基本要求进行设计。`,
  t233: `可持续发展贷款`,
  t234: `我们与9家主要的国际及本地银行成功签署首笔39 亿港币可持续发展挂钩银团贷款。本公司共选择3个ESG相关指标，分别为温室气体排放强度、水资源使用强度及ESG培训时数，并设定相应目标，通过实现目标即可减少成本的激励方式，督促本公司提升可持续发展绩效表现。`,
  t235: `保利置业坚决贯彻「廉洁自律，干凈干事」的理念，深入推进「不敢腐、不能腐、不想腐」体制机制建设。我们制定了《保利置业集团有限公司廉洁风险防控手册》《保利置业关于推动廉洁教育走深走实的实施意见》等内部制度，明确道德红线，竭力打造公正廉洁的营商环境和文化氛围。报告期内，本集团未发生贪污腐败相关的诉讼和案件。`,
  t236: `保利置业开展商业道德及反贪腐`,
  t237: `培训`,
  t238: `次`,
  t239: `累计参与`,
  t240: `人`,
  t241: `培训总时长`,
  t242: `小时`,
  t243: `其中，向董事提供的商业道德及`,
  t244: `反贪腐培训共计`,
  t245: `举报机制`,
  t246: `本集团建立了完善的举报机制，支持员工、供货商、合作伙伴通过信访地址、电话、电子邮箱等渠道进行实名或匿名举报。我们严谨受理每一个举报投诉，全力维护公司的廉洁文化。`,
  t247: `投诉举报接收`,
  t248: `举报信函和提交的书面材料：逐件拆阅、登记，及时处理，严防举报信件丢失`,
  t249: `当面举报：单独进行沟通，详细记录；电话举报：细心接听，如实记录`,
  t250: `短信、微信、电子邮件进行的举报：整理成文字材料，并注明来源和日期`,
  t251: `分类处理`,
  t252: `属于集团审计和风险管理中心受理范围的举报，填写《保利置业集团有限公司信访举报问题线索呈办单》`,
  t253: `属于子公司审计和风险管理中心受理范围的举报，发函转交相关子公司处理`,
  t254: `为保护举报人隐私及安全，我们在调查处理实践过程中，案件核查人员须签订《保密承诺书》，严防泄露举报内容及信访个人信息，力求确保所有员工不会因为表达关切或报告不合规或不合法行为遭受不当伤害。任何对举报人进行报复的个人或团体公司将视情节进行相应处罚，并为员工提供相应的保护措施。`,
  t255: `举报政策`,
  t256: `版权声明`,
  t257: `本网站上为版权人所有的文件，在此并末作任何授权。本网站上的文件仅限于为信息和非商业或个人之目的使用，并目不得在任何网络计算村上复制或公布，也不得在任何媒体上传播。未经版权人许可，任何人不得擅自(包括但不限于:以非法的方式复制、传播、展示、镜像、上载、下载)使用。否则版权人将依法追究其法律责任。`,
  t258: `免责声明`,
  t259: `版权人拥有对本网站的内容进行随时更改之权利，事前将不会另行通知。版权人不保证或声明本网站展示的资料是否正确、全面或是最新数据。`,
  t260: `本网站内的所有图片(包括但不限于插图、透视图、设计图等)、模型、文字描述等，仅作为参考信息，非开发商的任何承诺或要约，开发商声明:网站有关其开发项目信息的介绍，均以政府最后审批文件为准。商品房买卖双方之间的关系以当事人签订的买卖双方之间的关系以当事人签订买卖合同为准。`,
  t261: `任何人因本网站或依赖其内容进行交易所引致的损失，版权人和开发商均不承担任何责任。`,
  t263: `保利置业海南半岛1号游艇荟荣膺GFDA2024 Gold Winner 休闲建筑类金奖`,
  t264: `心安吾乡丨二十载卓越同行，领创美好心安荆楚`,
  t265: `限时投票！速来助力致美红盘C位出道`,
  t266: `心安家书 | 家音寄暖，点亮人文服务之光`,
  t267: `保利置业合约销售额 截至2024年11月30日止十一个月约为人民币521亿元`,
  t268: `保利置业合约销售额 截至2024年10月31日止十个月约为人民币489亿元`,
  t269: `公司通讯 - 2024年第三期`,
  t270: `保利置业合约销售额 截至2024年9月30日止九个月约为人民币402亿元`,
  t271: `高端地产开发`,
  t272: `探索更多`,
  t273: `积极践行央企责任与担当`,
  t274: `本集团将永葆初心使命，贯彻新发展理念，提升精益管理水平，为经济发展、民生改善贡献保利力量。`,
  t280: `品质五力`,
  t281: `保利置业敏锐洞察行业发展趋势，夯实"品质五力"核心竞争力，以向上攀升的卓越追求，实现企业高品质发展。`,
  t287: `绿色开发`,
  t288: `绿色经营`,
  t289: `绿色生态修复`,
  t290: `在国家「碳达峰、碳中和」战略目标背景下，保利置业积极探索房地产行业绿色高质量发展路径。本集团秉持绿色投资与设计理念，遵循《绿色建筑评价标准》（GB/T 50378-2019）要求，推进绿色建筑开发，不断探索绿色建筑技术开发、材料应用与建造实践，打造绿色建筑典范，共筑美丽家园。`,
  t291: `绿色建筑`,
  t292: `我们承诺，100%的新获取项目将至少按照中国绿色建筑基本要求进行设计。`,
  t293: `上海保利印象青城`,
  t294: `超低能耗建筑`,
  t295: `建筑(1.2版)银级认证`,
  t296: `上海保利琅誉`,
  t297: `近零能耗建筑`,
  t298: `上海兰州路项目`,
  t299: `济南保利珑誉`,
  t300: `绿色三星建筑`,
  t301: `香港朗誉`,
  t302: `绿建环评新建`,
  t303: `绿色建材`,
  t304: `在建筑建材的选择上，我们在注重材料质量的同时，优先选用低消耗、低能耗、无污染、多功能的材料。2023年，我们持续提高绿色建材要求，探索绿色建材应用。`,
  t305: `绿色建材应用`,
  t306: `防水材料使用环保性能更优的高分子卷材、可挥发性物质含量更低的聚氨酯涂料等`,
  t307: `外墙采用外墙保温一体化板，提高建筑物保温隔热性能`,
  t308: `多联机空调要求使用R410A环保冷媒，无毒，不含氯元素，不对臭氧层产生破坏，更加安全健康`,
  t309: `绿色技术`,
  t310: `装配式技术`,
  t311: `本集团在建造技术上逐步推进装配式建筑标准化设计和生产体系建设，扩大标准化构件和部品部件的使用规模，提高建筑综合效益。在装配式建筑的技术应用上，我们不断采用、实践新型技术标准，提高项目质量和效益，以技术带动绿色发展。`,
  t312: `BIM技术`,
  t313: `本集团全面推广应用BIM技术，通过数字化协同发展实现校验设计图纸、减少设计错漏、提升沟通效能等功能，全面提高施工进度和管理效率，在设计和规划过程中加强环境分析，提高材料与资源的节约利用水平。2023年，我们已通过地下室管线综合BIM应用及精装户型套内BIM应用两种场景实现项目的精细化管理。`,
  t314: `本集团高度重视在商业租赁、物业服务、酒店管理和日常办公等领域的绿色经营管理，完善我们在经营过程中的环境管理体系，加强节能减排、资源节约和废弃物管理等方面的绿色实践，助力建设资源节约型和环境友好型社会。`,
  t315: `绿色租赁`,
  t316: `为大力发展绿色租赁、提高可持续商业营运水平，本集团不断探索绿色商业管理模式，要求所有租赁入驻商户遵守国家和行业的环境保护政策法规，在租赁期间规范和协助租户践行绿色低碳理念，改善节能、节水、减少废弃物排放等方面的环境表现。`,
  t317: `商户装修`,
  t318: `制定《装修管理作业指导书》，对于商户装修期间的能源、水、废弃物排放、噪音等进行严格管控，实现绿色施工。施工单位进场前须签订《施工注意事项》，规定施工工期及时间、噪音施工时间，减少及防止施工环境噪音对客人、居民造成影响。施工现场垃圾必须经过包装后，按要求的路线运至指定的区域堆放，并及时清运到指定的处理场所，确保清运路径中公共区域的卫生整洁。`,
  t319: `租赁节能管理`,
  t320: `本集团高度重视资源管理，通过合理安排设备设施使用时间等举措节能减排，利用智能化设备等方式提高水资源使用效率，助力实现绿色低碳营运。`,
  t321: `绿色物业`,
  t322: `本集团持续贯彻落实绿色营运措施，推进物业管理的低碳转型和可持续发展，打造绿色服务品牌。保利物业、保利（香港）物业在营运管理的过程中承担环境保护的责任，严格遵守环境相关法律法规，践行绿色营运管理，并已获得ISO14001环境管理体系认证。`,
  t323: `多晶硅光伏发电项目`,
  t324: `共计421块光伏电池组，总面积达2,000平方米。在日照稳定的情况下，日综合发电量约为103千瓦时，年综合发电量约90,000千瓦时，光伏电池组通过逆变器把光能转换成电能，并网使用达到绿色使用能源的目的。`,
  t325: `中水站技术改造项目`,
  t326: `针对安宁宁湖峰境小区中水站进行维修和改造，将中水日处理能力由10立方米提升到25立方米以上，有效保障绿化浇水，提高水资源循环利用。`,
  t327: `绿色酒店`,
  t328: `本集团致力于建立健全低碳节约的绿色生态服务体系，不断提高酒店管理过程中的绿色营运水平。保利商旅采取了一系列环保措施，以减少酒店营运过程中对资源的消耗和对环境的影响，打造绿色酒店，塑造绿色环保的品牌形象，向每一位来酒店的住客传递绿色环保理念。`,
  t329: `酒店管理节能举措`,
  t330: `每月分析能源使用情况，根据各酒店入住率、气候、节能管理等方面对能源实际发生与预算的偏差进行对比和管控。`,
  t331: `在精益管理方面，各酒店推进常态化节能措施、设备改造等工作，如贵阳酒店对中央空调进行变频节能改造、对酒店楼层走道装饰照明灯进行分组控制改造。`,
  t332: `酒店管理节水举措`,
  t333: `各酒店客房按照设施状况和维修计划，陆续更换节水器具。`,
  t334: `公共区域全部更换为节水龙头。`,
  t335: `餐厅厨房区域严格要求节水管理。`,
  t336: `废弃物举措`,
  t337: `广泛宣传垃圾分类知识，在楼层设置分类垃圾桶。开展月度垃圾分类检查，及时发现问题并督促整改。`,
  t338: `严格控制清洁剂的发放和使用，加强对员工节约意识培训，提高环保意识。`,
  t339: `施工垃圾严格按要求包装清运处理。`,
  t340: `绿色办公`,
  t341: `本集团将绿色环保融入我们的经营理念，倡导绿色低碳的办公方式，鼓励所有员工积极参与智慧办公、节能降耗、资源节约、绿色出行等行动，共同创造健康、节约、低碳、环保、舒适的办公环境，构建环境友好型企业。`,
  t342: `智慧办公`,
  t343: `不断完善以OA办公平台为基础的审批流程整合，使用电子签章进行公文处理工作，既提高效率和合规性，也能降低用纸量`,
  t344: `使用文件共享平台同步会议材料，避免会议数据打印，大幅降低会议用纸数量`,
  t345: `进一步推进无纸化办公的建设，通过在线登记签字进行高效、规范化管理`,
  t346: `节能降耗`,
  t347: `提倡员工下班时养成随手关闭办公室照明灯、空调、电脑等电器设备`,
  t348: `会议结束后及时关闭会议室大屏和照明，及时清理冰箱内已过期物品等。同时，物业两小时巡楼一次，对节电举措落实情况进行巡查`,
  t349: `对能耗数据形成常态化收集、分析机制，及时发现异常情况并分析原因、制定整改举措`,
  t350: `资源节约`,
  t351: `所有洗手间安装感应水龙头，智能节水`,
  t352: `提倡员工参加部门内部会议时自带茶杯茶水，减少瓶装水的使用量`,
  t353: `优化纸张克重，推行文件双面打印，降低纸张耗量；在每层复印机间设置废纸箱，有效利用废纸、二手纸`,
  t354: `新增办公区优先使用闲置办公家具，在降低成本的同时减少装修污染，保护办公区生态环境`,
  t355: `绿色出行`,
  t356: `新增公务用车倡导优先采购新能源车，降低碳排放`,
  t357: `重新梳理公务机票、酒店的预定标准，进一步强调标准的严格执行`,
  t358: `鼓励员工乘坐公共交通通勤`,
  t359: `本集团积极响应国家双碳战略和绿色生态政策，坚持可持续发展的理念，将绿色投资理念融入公司的战略规划和房地产项目的全生命周期。为贯彻落实绿色投资理念，推动土地的良性开发，防止对生态破坏以及保护生物多样性，我们尽量避免在农田、绿地以及国家的自然保护区中拓展开发项目，并在项目开发过程中积极推动用地整治、生态修复等工作，助力创造美好生活环境。`,
  t360: `贵州公园2010项目`,
  t361: `配建社区公共绿地绿谷公园（红线外用地整治）`,
  t362: `贵州公园2010项目配建小区公共绿地绿谷公园，整体面积约4万平方米，原状为保利置业建设用地之间的荒芜绿地，植物杂乱，无法供周边的居民使用。本集团积极承担社会责任，在保障红线内住宅建设的同时对建设用地之间的灰空间进行了整治提升，根植于场地本身，融入自然元素，添加生活场景，形成了集公园漫步、儿童乐园、自然课堂、健身运动、聚会交流的公园慢活绿地，为周边居民提供集中运动休闲场所。`,
  t363: `万宁保利半岛1号`,
  t364: `海岸线生态修复`,
  t365: `海南老爷海岸线生态修复项目位于海南省万宁市神州半岛老爷海（内海）海边，海岸线长度约500米。保利置业在做好地块内住宅的同时，积极协同当地政府组织多次凈滩护海行动，逐步清除项目面海区域违建养殖鱼排。同时，因地制宜地进行生态恢复及综合整治工作，将昔日荒芜地块转变成了极具当地度假风情与烟火气的滨海公园，为当地小区与自然资源整治做出了贡献。`,
  t366: `海南老爷海岸线（修复前）`,
  t367: `海南老爷海岸线（修复后）`,
  t368: `公益资讯`,
  t378: `2024年中报`,
  t380: `保利置业集团有限公司`,
  t381: `董事`,
  t382: `执行董事`,
  t383: `万宇清先生（主席）`,
  t384: `胡在新先生（董事总经理）`,
  t385: `非执行董事`,
  t386: `陈育文先生`,
  t387: `独立非执行董事`,
  t388: `冯志坚先生`,
  t389: `梁秀芬小姐`,
  t390: `黄家伦先生`,
  t391: `吴剑林先生`,
  t392: `董事会委员会`,
  t393: `审核委员会`,
  t394: `提名委员会`,
  t395: `薪酬委员会`,
  t396: `环境、社会及管治委员会`,
  t397: `公司秘书及授权代表`,
  t398: `黄卓谦`,
  t399: `法律顾问`,
  t400: `竞天公诚律师事务所有限法律责任合伙`,
  t401: `核数师`,
  t402: `天职香港会计师事务所有限公司`,
  t403: `主要往来银行`,
  t404: `中国农业银行股份有限公司`,
  t405: `北京银行股份有限公司`,
  t406: `中国银行股份有限公司`,
  t407: `交通银行股份有限公司`,
  t408: `上海银行股份有限公司`,
  t409: `中信银行股份有限公司`,
  t410: `中信银行（国际）有限公司`,
  t411: `中国建设银行股份有限公司`,
  t412: `中国光大银行股份有限公司`,
  t413: `广发银行股份有限公司`,
  t414: `招商银行股份有限公司`,
  t415: `中国民生银行股份有限公司`,
  t416: `浙商银行股份有限公司`,
  t417: `招商永隆银行有限公司`,
  t418: `华夏银行股份有限公司`,
  t419: `中国工商银行股份有限公司`,
  t420: `中国工商银行（亚洲）有限公司`,
  t421: `兴业银行股份有限公司`,
  t422: `马来亚银行有限公司`,
  t423: `平安银行股份有限公司`,
  t424: `中国邮政储蓄银行股份有限公司`,
  t425: `上海浦东发展银行股份有限公司`,
  t426: `股份过户登记处`,
  t427: `香港中央证券登记有限公司\n香港湾仔皇后大道东183号\n合和中心17楼\n1712–1716室`,
  t428: `注册办事处`,
  t429: `香港夏悫道18号\n海富中心一座25楼2503室`,
  t430: `公司网址`,
  t431: `最后更新日期`,
  t432: `年`,
  t433: `月`,
  t434: `日`,
  t435: `本公司就有关董事进行证券交易之行为守则已采纳上市规则附录C3上市发行人董事进行证券交易的标准守则（「标准守则」）。于企业管治报告期间内，全体董事已妥为遵守标准守则。`,
  t436: `组织章程细则`,
  t437: `董事名单与其角色和职能`,
  t438: `职权范围`,
  t439: `审核委员会`,
  t440: `薪酬委员会`,
  t441: `提名委员会`,
  t442: `主要附属公司董事名单`,
  t443: `年主要附属公司董事名单`,
  t444: `主席及董事总经理之职责分工`,
  t445: `举报政策`,
  t446: `股东提名人选参选董事的程序`,
  t447: `股东通讯政策`,
  t448: `股东权利`,
  t449: `补发遗失股分证明书`,
  t450: `根据香港《公司条例》有关补发已遗失的上市公司股分证明书之公告`,
  t451: `拟发出新股份证明书的公告`,
  t452: `有关取消原有股份证明书及发出新股份证明书的公告`,
  t453: `点击查看`,
  t454: `传真`,
  t455: `投资者/传媒查询`,
  t456: `廉政信访举报`,
  t457: `举报`,
  t458: `信访`,
  t459: `举报政策`,
  t465: `负责任供应链`,
  t466: `践行社会责任`,
  t467: `本集团制定了供应链全生命周期管理流程，通过在供应商准入及管理环节将 ESG 因素纳入考虑，加强负责任供应链管理与可持续采购管理，共同促进价值链的可持续发展。`,
  t468: `供应商管理体系`,
  t469: `本集团严格遵守《中华人民共和国招标投标法》《中华人民共和国招标投标法实施条例》《中华人民共和国政府采购法》等法律法规，制定《保利置业集团招标管理制度》《保利置业集团供方管理制度》《保利置业集团集中采购供方管理办法》等内部管理制度。通过制度明确供应商引入、评估、分级管理等全生命周期的管理行为及流程，构建供应链「选、用、育、评」的动态管理机制。`,
  t470: `供应商引入`,
  t471: `针对不同类别的供应商，我们设立了专项入库考察标准，从资质、产品、质量、标杆业绩等多方面筛选合格供应商，打造优质供应商库。`,
  t472: `供应商评价`,
  t473: `在前期设计配合、合同签订、施工（或排产供货）、验收及售后服务等各个阶段，我们对供应商进行全面评价，以促进其履约能力的提升和服务质量的提高，同时优化供方的管理水平。`,
  t474: `供应商分级管理`,
  t475: `激励机制`,
  t476: `针对评价为「优秀」的供应商，我们采取奖励措施，以表彰其卓越表现。`,
  t477: `退出机制`,
  t478: `对于评价为「不合格」的供应商，我们执行退出机制，不断优化供应商资源库，确保供应链的整体质量。`,
  t479: `可持续采购`,
  t480: `我们将劳工准则、职业健康与安全、产品质量、环境保护、反贪腐与商业道德等ESG 指标纳入供应商准入和评估的考察范围，确保采购的合规性，降低供应链风险，积极推进可持续采购的践行。`,
  t481: `供应商ESG管理`,
  t482: `本集团制定并向供应商宣贯《保利置业集团供应商行为准则》，要求供应商签署《遵守保利置业集团供应商行为准则的承诺书》，将ESG 理念延伸至供应链上下游各环节，提升供应商的可持续发展表现。我们在供应商引入阶段设置ESG 考虑，要求供应商提供管理体系认证，包括但不限于信用等级证书、质量管理体系、环境管理体系、职业健康与安全管理体系等ESG 管理相关认证证书。我们通过供应商约谈、调研、巡检等方式，对供应商现状、管理制度、操作流程、评估奖罚等方面开展供应商梳理工作，加强供应商管理和社会责任等方面的评估分析和可持续能力建设。`,
  t483: `廉洁管理`,
  t484: `绿色采购`,
  t485: `我们践行绿色采购理念，优先采购具有可持续认证、低消耗、低能耗、无污染、多功能的绿色产品，引导供应商主动提高产品质量和环保性能，持续降低可能造成的环保风险，推动全产业链的绿色发展。`,
  t486: `沟通与培训`,
  t487: `本集团重视和供应商的沟通与交流，持续维系良好的合作关系，积极为供应商提供支持与帮助。我们通过多种沟通渠道，围绕质量、健康与安全、可持续发展等方面与供应商及时沟通，积极开展供应商培训和整改，帮助供应商加强能力建设，实现合作共赢。`,
  t488: `「筑城筑信，共筑美好」 供应商大会`,
  t489: `为进一步强化与供应商的沟通互信，深化质量意识和履约精神，保利置业上海公司于2024 年1 月举办了「筑城筑信，共筑美好」为主题的2023 年度供应商大会，宣贯工程、成本、设计条线的管控要求，对优秀供应商进行表彰，实现与供应商的深入交流、携手并进、合作共赢。`,
  t490: `保利少年志`,
  t491: `2021年，保利置业正式启动保利少年志公益活动。带领9名大山少年飞跃大山，圆梦北京之旅，并在贵州册亨县学校捐建"保利艺术教室""保利梦想图书室"。2022年，开展"保利少年志·千里课堂"，全国11位梦想导师跋涉9300余公里，为66名大山孩子带来人文、艺术、理想启蒙课程。2023年，首次联动"保利星火教育金"，在全国7个定点帮扶县设置"保利少年志·星火教育金"，共捐赠210万元、覆盖1289名师生，巩固脱贫攻坚成果，夯实人才振兴、文化振兴的重要基石。`,
  t492: `社区回馈`,
  t493: `本集团致力于为社区创造价值，注重与小区居民建立紧密的联系，了解他们的需求和期望，并提供相应的支持和帮助。同时，我们也鼓励员工积极参与社区回馈活动，培养他们的社会责任感和公民意识。`,
  t494: `「学习二十大 志愿新征程」学雷锋青年志愿服务活动`,
  t495: `2023年3月，保利置业上海公司组织开展「学习二十大志愿新征程」学雷锋青年志愿服务活动。青年志愿者们前往福利院为老人提供慰问与慰问品，在减少老人的孤独感，提升老人幸福感的同时进一步弘扬「奉献、友爱、互助、进步」的志愿精神。`,
  t496: `第六届「为孤独症行走」大型公益徒步活动`,
  t497: `2023年4月，保利置业江苏公司联合太阳花儿童服务中心等机构举办以「点亮星空，爱不孤独」为主题的第六届「为孤独症行走」公益徒步活动。本次活动深化了公益品牌建设，提高社会对孤独症群体的关注度，助力他们更好地融入社会。`,
  t498: `「铸牢中华民族共同体意识」主题团日活动暨少数民族青少年「手拉手」`,
  t499: `2023年，保利置业广西公司团员和少数民族青年员工参观民族村，体验广西的多元文化，向小学生宣传民族团结教育，增强团员青年的民族文化自信和爱国情怀，引导青少年增强文化认同和民族团结意识。`,
  t500: `「全民国家安全教育日」宣传志愿服务活动`,
  t501: `2023年4月，在「保利乐跑中国」广西站活动中，我们别出心裁地组织了「国家安全知识飞盘趣味竞答」，以轻松有趣的方式向业主、员工及公众传递国家安全知识。此举在全民国家安全教育日之际，有效地提升大家对国家安全的认识，增强全民维护国家安全的共识。`,
  t502: `保利物业「「衣」爱之名，助力公益」家庭闲置衣物捐赠循环利用公益活动`,
  t503: `2023年，保利置业江苏公司携手爱心业主，开展「「衣」爱之名，助力公益」家庭闲置衣物捐赠循环利用公益活动，向贫困山区孩子们传递温暖与爱意。`,
  t504: `义工行动`,
  t505: `本集团积极参与美好小区的建设，开展义工活动。在义工行动中，本集团志愿者们深入小区，用实际行动践行企业社会责任，让更多的人感受到企业的关怀和帮助。`,
  t506: `助力集士港卖面桥村老年活动中心建设`,
  t507: `2023年2月，保利置业浙江公司赴卖面桥村老年活动中心进行捐赠活动，为老年活动中心送去健身设备、娱乐设施、空气凈化器等物品。`,
  t508: `「3.12」义务植树志愿服务活动`,
  t509: `2023年3月，我们积极开展义务植树志愿服务活动，进一步增强员工环保意识，践行绿色发展理念，为生态文明建设贡献「保利力量」。`,
  t510: `「守护昆明冬日小精灵」护鸥行动`,
  t511: `2023年，保利置业云南公司在昆明海埂开展「守护昆明冬日小精灵」护鸥行动，各部门团员青年代表参加本次主题活动。志愿者们主动向市民、游客宣传科普保护红嘴鸥的相关知识，提高广大市民、游客爱鸥护鸥意识。`,
  t512: `「志愿服务进工地」慰问农民工活动`,
  t513: `2023年3月，保利置业贵州公司开展「志愿服务进工地」慰问农民工活动。通过发动青年志愿者服务队走进工地，为辛勤劳作的工人们送去热腾腾的午餐，并在用餐的间隙宣传预防甲流的方法和措施。`,
  t514: `「生活读享季 书香进社区」公益活动`,
  t515: `2023年4月，保利置业广东公司举行「生活读享季 书香进小区」公益活动，向全小区广大群众发出爱读书、读好书、善读书的号召。本次公益活动为期一个月，捐赠各类书籍共400 余册，同时在小区党群服务中心设立「文化驿站」，定期安排公司志愿者在现场开展志愿服务，健全现代公共文化服务体系。`,
  t520: `精美产品`,
  t521: `精心服务`,
  t522: `客户权益`,
  t523: `保利置业秉承"追求极致产品和服务质量" 匠心精神，在"保利是吾乡"全新品牌发展观的引领下，以"至真·致美·置吾乡" 的全新产品品牌，承接使命愿景，指导产品精神，链接客户感知，打造具有卓越竞争力的品牌生态链。`,
  t524: `POLYLIGHT\n人居四感体系`,
  t525: `打造夯实的产品价值底盘，既贯彻了以客户为中心，触达业主真正居住需求的产品理念，又起到了产品细节落地过程中的严格品控作用，为项目提供高质量的技术模块和指引规范。`,
  t526: `致美生活图谱`,
  t527: `以聚焦市场新趋势和客户新需求的视野，在产品力精进的道路上实现产品体系的持续叠新。以「甲第系、誉系、赋系、印系、壹号系」五条产品线，为每类客户提供专属的美好生活方式。`,
  t528: `甲第系`,
  t529: `稀贵显赫藏品`,
  t530: `坐拥城市珍稀资源，\n雕琢不可复制的藏品之作。\n为极少数定制\n以身份和品位的非凡象征，\n标定人生高度。`,
  t531: `誉系`,
  t532: `高定艺术瑰品`,
  t533: `接轨国际的臻美定制，\n辉映时代风华。\n以城市高阶生活的质量引领，\n兑现极致风范。`,
  t534: `赋系`,
  t535: `厚韵传著之作`,
  t536: `为城市赋以精神意象，\n以文化传着\n以设计言志。\n溯源东方人文精神，\n探寻人文华宅的当代表达。`,
  t537: `印系`,
  t538: `灵感心造之作`,
  t539: `敛藏时光丰盛\n印见烟火生活日常。\n以有温度有格调的质量居所，\n书写家的温情美好。`,
  t540: `壹号系`,
  t541: `山水栖心之作`,
  t542: `得天独厚的天赋资源下，\n构筑宜居家园。\n以辽阔的天地滋养\n创造生命的共振与连接。`,
  t543: `焕新智慧家园`,
  t544: `引进先进的智能化设备，全面提升公共系统，打造智慧化住宅和社区，以高质量、高标准、高科技、高品位焕新智能化人居体验新高度。`,
  t545: `打造智慧社区`,
  t546: `保利置业在深圳保利龙誉、保利雍山郡、保利明玥澜岸花园和静安府等项目中，创新打造智慧社区（智慧出行、智慧安全、智慧设施、智慧服务）、共享社区、绿色社区、无忧社区、室内增值共五大模块，并在此基础上增设「归家体验」的升级模块。\n\n在创意样板房引入智能家居提升项，展示智能中控屏、智能灯控系统、电动窗帘电机等智能设备，提供了良好的场景氛围。在大区设计中，配备了智能车牌识别、人脸识别门口机、高空抛物监控、车库一氧化碳浓度检测、智能门锁、户内可视对讲等设备，打造人行车行的无感通行，营造智能、低耗、节能、健康、便捷的智慧之家。`,
  t547: `智能中控系统`,
  t548: `保利置业在山东保利珑誉项目上采用可视对讲兼智能中控系统。户内10.1寸中控屏，既是可视对讲室内机，也作为全屋智能控制终端，并兼具语音识别功能，实现全屋智能设备语音控制。\n\n该项目还引入了智能照明系统，根据场景模式开闭不同灯光，营造不同居家氛围，满足不同生活场景。业主可以通过智慧生活APP轻松远程控制客餐厅的所有灯具，实现便捷的智能管理。\n\n此外，为方便老人使用，客餐厅所有灯光均可实现墙面开关、中控屏、语音等方式控制，确保他们能够更加自如地操作。`,
  t549: `保利置业始终以客户价值战略为导向，致力于为客户提供专业、温暖且高效的服务，共同创造美好生活`,
  t550: `物业管理`,
  t551: `保利物业始终以品质为先，秉承「让生活更美好」的服务理念，构建「人+物+时间」结合的服务模式，形成「空间+ 时间」的服务特点，利用「智能化」科技手段，着力打造安全与安心并行的全方位服务体系。2023 年，保利物业、保利（香港）物业均已通过ISO9001质量管理体系认证。`,
  t552: `保利物业为客户提供高端定制化服务，坚持全时态的服务标准，为客户提供始终如一的高质量服务。`,
  t553: `高端定制服务`,
  t554: `依据业主群层和客群的特点，深入探究和发掘业户对于质量生活的个性化需求，围绕业户生活的「衣、食、住、行、康健」育儿、养生、社交等需求，提供定制化服务，实现随需而动的尊崇体验。`,
  t555: `专属服务`,
  t556: `为新收楼的业户提供礼遇新禧交付服务。为每一户收房的业主举办一个小型、简短、隆重的金钥匙交房仪式。`,
  t557: `服务标准`,
  t558: `365天、24小时的全时态、不间断服务，30分钟快速响应，始终关注守护客户的安全。专属管家服务，随需而动，始终关注客户的所需所想，让尊崇体验不间断。`,
  t559: `酒店服务`,
  t560: `保利商旅为本集团旗下的酒店管理平台，负责自营酒店项目的经营管理及新项目受托管理开发等。\n保利商旅聚焦全周期客户体验，主要以客户信息管理、客户关系管理维护、客户满意度调查等方式为主，并根据客户投诉制定行动解决方案，不断提升酒店服务管理水平，让每一位顾客宾至如归。`,
  t561: `保利置业致力于全方位保障客户权益，通过严密的隐私保护机制、高效的投诉处理和合规的营销行为，为客户提供安全可靠的服务体验。`,
  t562: `客户满意度`,
  t563: `保利置业持续开展客户满意度调研。各区域通过小区焕新、维修增值等各类触点行动增强业主粘性，客户满意度整体呈正反馈。2023年集团总体满意度较2022年提升12%。`,
  t564: `客户诉求响应`,
  t565: `搭建了多渠道客户沟通和投诉机制，涵盖400呼叫中心、微信公众号、客服、管家企业微信、房修等。2023年，本集团400呼叫中心团队迭代升级，立足于高效处理各阶段业主报事报修及要求服务，年度7*10h无休接听，为客户提供更加系统和全面服务。2023年集团客户投诉处理率98%。`,
  t566: `负责任营销`,
  t567: `保利置业严格遵守《中华人民共和国广告法》《商品房销售管理办法》等法律法规，并建立了《保利置业集团有限公司营销管理制度》等内部管理制度，切实践行合规营销，确保宣传物料的真实可靠。`,
  t568: `2023年，本集团加强营销廉政建设，持续深化营销风控意识，共抽查了65项营销业务，并对相关320 项流程进行巡检和评审。`,
  t569: `信息安全及隐私保护`,
  t570: `本集团严格遵守《中华人民共和国个人信息保护法》《中华人民共和国数据安全法》《中华人民共和国网络安全法》等法律法规，建立了完善的数据安全管理体系，全方位保护客户信息安全。通过及时管控信息安全风险，不断提升本集团的信息安全等级，保障客户合法权益不受侵害。`,
  t571: `通过微信小程序、APP等端口向客户提供多元化服务，所有客户行为数据的获取都需要客户同意签署《数据隐私协议》。`,
  t572: `严格执行数据安全备份管理`,
  t573: `严格落实数据安全备份管理，数据在正式上线前，应用系统负责人必须提交数据库和附件的备份策略和备份脚本，并完成本地备份。同时，对于应用系统数据库备份周期及保留时长进行严格要求。`,
  t574: `数据脱敏处理`,
  t575: `在数据的管理与运用过程中，均做到客户手机号、身份信息的脱敏处理，避免项目一般人员接触到敏感数据。同时，在数据在传输过程中也进行了数据加密码处理。定期进行数据安全相关法律知识的培训。`,
  t576: `系统分级权限控制`,
  t577: `处理数据时严格遵循数据管理流程，分为申请、审批、转发、修改、检查、启用六大步骤。\n24小时不间断监控监控数据文件的备份、保存与归档、保密等工作。`,
  t578: `数据运维安全管理机制`,
  t579: `服务器或数据的运维都需建立在安全的运维链路上。\n对于所有访问系统的行为，均作日志记录。`,
  t580: `CRM系统本地化部署`,
  t581: `CRM 系统完成本地化部署，数据安全性得到全面提升。`,
  t591: `2024年中报`,
  t593: `保利置業集團有限公司`,
  t594: `集团要闻`,
  t595: `媒体聚焦`,
  t596: `多媒体中心`,
  t598: `关注保利置业`,
  t608: `人才发展`,
  t609: `人才理念`,
  t611: `人才培养`,
  t612: `人才招聘`,
  t613: `德才兼备 以德为先`,
  t614: `坚持"德才兼备、以德为先"的人才标准，推行"责任心、综合素质、专业能力"的人才评价排序，从政治素养、自我领导力、团队领导力、业务领导力四个维度出发，构建"1+6"保利置业领导力素质模型，统一人才共识。`,
  t615: `知行合一`,
  t616: `秉承"明理 、笃行、 善进"与"知行合一"的人才观，让每一位保利置业人知行合一、把握大势、按规矩办事，保持战略定力，持续精进，实现个人价值与社会价值的统一。`,
  t617: `明理`,
  t618: `，明辨是非，把握大势。`,
  t619: `笃行`,
  t620: `，坚定信念，践履所学。`,
  t621: `善进`,
  t622: `，积极进取，勇毅前行。`,
  t623: `明理而笃行，笃行而善进`,
  t624: `以知促行、以行促进，助力保利置业高质量发展。`,
  t630: `岗位名称`,
  t631: `所属机构`,
  t632: `工作地点`,
  t633: `党务管理（校招）`,
  t634: `集团总部`,
  t635: `上海`,
  t636: `岗位职责：`,
  t637: `1、负责保利置业基层党组织建设工作，并配合党委办公室开展相关工作。`,
  t638: `岗位要求：`,
  t639: `1、中共党员；
2、应届生硕士研究生及以上学历；
3、具备国、央企党务工作经验者优先；
4、工作认真细心，责任心强，性格开朗，具有较强文字能力，组织和沟通协调能力。`,
  t640: `投递邮箱：`,
  t641: `新闻宣传（校招）`,
  t642: `1、负责保利置业新闻宣传及舆情管理相关工作。`,
  t643: `1、中共党员；
2、应届生硕士研究生及以上学历，新闻传播、汉语言文学、中文等相关专业优先；
3、具备扎实的文字功底和写作能力，了解国央企新闻传播特点，有较强的新闻敏感性，公众号编辑能力和创新意识，具备选题、活动策划和新闻宣传整合和执行能力；
4、熟练掌握视频编辑技能、有互联网平台内容制作岗位或运营岗位经历者优先。`,
  t644: `数字天军`,
  t645: `1. 根据公司业务发展，负责房地产营销数字化创新业务规划的路径分解和实施落地；
2.负责创新业务模式的探索、落地及其他相关日常工作相关，如业务需求的沟通协调、业务梳理，推动项目落地；
3.负责创新业务模式的建立和运营陪跑论证；
4.负责实施过程中的项目管理，推进软件产品的开发、实施、上线和运维，确保产品品质；
5. 辅助创新模式下的营销体系变革支持与协调；
6. 识别总体业务需求，注重横向协作，解决过程中遇到的问题，疑难杂症。`,
  t646: `1、全日制本科及以上学历，5年以上数字化或营销类业务创新经验者优先；
2.对企业数字化转型相关领域有足够认知洞察能力，并能前瞻性地理解技术发展趋势和应用场景，结合公司情况进行实践探究；
3.对线上营销有深刻认知，具备相关项目成功经验者；
4.对产品创新、业务创新、业务运营有一定的见解，善于解题答题；
5.具备良好的数据分析能力，对数字型数据较为敏感。`,
  t647: `机电设计`,
  t648: `1.负责公司机电条线设计管理工作，负责区域机电设计方案审核工作；
2.负责专业标准化及创新研发工作；
3.负责建立与完善专业制度标准工作，包括工作流程、管理制度；
4.负责设计资源的拓展与管理，管理设计供应商库，完善供应商管理制度、评价流程；
5.协助集采的选型定样，完善集采品类、规范定样标准等。`,
  t649: `1.本科及以上学历，电气专业背景，熟悉水暖电全专业相关知识。
2.品质房企集团或500亿体量区域经验优先；
3.具备条线体系管控经验，包括且不限于资源库搭建、条线培训、考核、标准化、创新研发等工作。
4.5年以上住宅设计管理经验，具有高端住宅/公建机电管理经验。熟悉国家及地区设计相关管理制度及技术规范；有较强的专业设计和技术管理能力，有较强的逻辑思维；
5.认真负责，主动思考，具有创新精神；有较强的横纵向沟通协调能力，具有团队精神，能够承担较大的工作压力和挑战。`,
  t650: `战略研究`,
  t651: `1.跟踪研究行业市场、政策、土地，对行业走势形成全面跟踪，对趋势做好预测，把握周期的风险和机遇，指导投资策略的拟订，投资标准和原则的优化；
2.跟踪研究竞企的经营策略、城市布局策略、投资策略，挖掘可以借鉴的重要信息；
3.研究拟定公司投资策略，开展区域、城市及板块投资布局分析；
4.完成代建、商业、自持租赁住宅等相关专题研究工作；
5.配合上级单位和集团总部，完成布置和协同的相关研究工作；
6.配合投资管理和拓展的相关工作。`,
  t652: `1.年龄40岁以下，工程管理、管理科学与工程、房地产与土地管理、技术经济及管理、金融相关专业优先；
2.系统掌握房地产市场分析的方法论，有丰富的研究经验；
3.工作认真仔细、责任心强，能够快速适应工作环境带来的全新挑战，具有一定的抗压能力；
4.标杆房企相关岗位或标杆乙方智库5年以上，有投资拓展工作经验优先。`,
  t659: `建立"睿见、睿知、睿才"三级人才培养计划
致力于打造从优秀到卓越的管理人才梯队`,
  t660: `优秀管理者`,
  t661: `聚焦专业度、关注专业管理能力，旨在培养强执行、擅协作、能成事的优秀高潜（未来）管理之才。`,
  t662: `专业经营者`,
  t663: `聚焦经营思维，关注运营能力，旨在培养善思明智、懂经营会管理的专业经营之才。`,
  t664: `卓越领导者`,
  t665: `聚焦组织能力、干部人才梯队建设、企业文化塑造，旨在培养能够引领组织、达成业绩、创造价值、创新变革的卓越之才。`,
  t666: `从优秀到卓越的管理团队`,
  t667: `卓越科技
与健康同行`,
  t668: `全国标准`,
  t669: `项`,
  t670: `行业标准`,
  t671: `国家专利`,
  t672: `余项`,
  t673: `高新技术企业评为`,
  t674: `次`,
  t675: `保利星 保利微芯`,
  t676: `北京保利星数据光盘有限公司由保利置业集团有限公司、保利国际控股有限公司共同投资，于1999年7月成立。保利星是国家新闻出版总署认定的首批《国家光盘复制示范企业》，是全国光盘复制企业中唯一一个连续获得五届印刷复制奖的企业。先后制定国家标准3项、行业标准20项，获得国家专利10余项。自2001年起至今连续七次被评为高新技术企业。`,
  t677: `2019年8月保利星公司将微流控芯片业务剥离，由保利置业集团有限公司投资成立了北京保利微芯科技有限公司。凭借在微流控芯片设计领域的技术积累和创新实力，保利微芯成功被认定为国家级高新技术企业、北京市专精特新中小企业。产品实现了用于循环肿瘤细胞捕获、单细胞捕获、微液滴生成检测、单细胞微珠液滴等微流控芯片产品，实现对国外产品的替代，达到国际同等水平。目前已取得专利8件，其中发明专利4件。通过ISO13485医疗器械行业质量管理体系认证。与北京工业大学共建了"产学研联合培养研究生基地"。`,
  t678: `境内外高端房地产开发`,
  t679: `保利置业深刻学习领会中央重大战略部署，深耕长江经济带、粤港澳大湾区、环渤海经济带以及西南和东北面向东盟、东北亚开放战略核心区，精筑中国三十城，业务遍及上海、北京、香港、广州、深圳、杭州、重庆、武汉、济南、哈尔滨、贵阳、南宁、昆明、苏州、宁波、佛山、烟台、万宁等城市，开发投资近200个项目，为60万中国家庭、200万中国人实现安居梦想，先后投资开发北京新保利大厦、北京保利大厦、上海保利广场、上海证券大厦、上海保利大剧院、广州中信广场、武汉保利广场等城市地标建筑，已成为城市名片。`,
  t680: `个`,
  t681: `项目`,
  t682: `万`,
  t683: `中国家庭`,
  t684: `中国人`,
  t685: `扫一扫,关注保利置业`,
  t686: `上海保利广场`,
  t687: `上海保利广场是保利置业在上海的旗舰项目和总部办公区，占有极为稀缺的黄浦江观景资源和上海金融中心功能区的区域资源，由双塔蝶形主楼、四栋钻石切割状的独栋办公楼和四个下沉式广场组成，创陆家嘴办公楼层高之最。`,
  t688: `北京新保利大厦`,
  t689: `位于北京市东城区东四十条桥西南角，于2007年开盘，是集高档写字楼、博物馆及商业娱乐设施于一体的绿色智能化大厦，被誉为"北京新地标"。拥有以抢救圆明园国宝而闻名的保利艺术博物馆，与保利大厦和保利剧院遥相呼应，成为北京一处重要的文化景观。`,
  t690: `北京保利大厦`,
  t691: `保利大厦酒店于1992年正式成立，是一座集客房、写字楼、剧院、餐饮、娱乐、会议设施为一体的综合型四星级商务酒店，1997年被国家旅游局评为"中国旅游行业标志性建筑"，已通过ISO9001质量体系认证，获得"北京市优秀物业管理大厦"和"北京晚间优秀活动场所"的称号，2003年被中国饭店协会评定为5A级"中国绿色饭店"。`,
  t692: `上海保利大剧院`,
  t693: `坐落于上海市嘉定新城中心区，面向生态美境远香湖，建筑面积达5.6万平方米，总投资约7亿人民币，由享誉世界的建筑大师安藤忠雄担纲设计，上海保利大剧院揉汇了国际尖端建筑潮流与传统人文美学精神，营造出一个自然、建筑、艺术、人类彼此和谐相容、自在对话的公共艺术交流空间。`,
  t694: `广州中信广场`,
  t695: `广州中信广场位于中国广州市天河区商业、金融业繁华的天河北路，占地2.3万平方米，总建筑面积29万平方米，1997年建成时为当时中国的最高建筑，也是世界上最高的混凝土大厦。它面向天河体育中心，背后是广州火车东站和广州地下铁总站，地理位置优越，拥有办公商住环境，落成不久即广州的标志性建筑之一，是很多全球500强公司在广州的办公地点。`,
  t696: `深圳保利文化广场`,
  t697: `深圳市保利文化广场是中国保利集团首个"文化商业地产"项目，于2004年9月3日举行奠基仪式，2007年12月31日保利剧院完成首场演出，2008年3月8日项目全面开业。地处南山城市双中心发展的西部滨海CBD－深圳湾后海商圈，是集特色餐饮、零售百货、文化娱乐、休闲体验类业态的大型综合商业中心。`,
  t698: `上海证券大厦`,
  t699: `上海证券大厦位于浦东陆家嘴金融贸易区中心，由中国保利集团和上海证券交易所联合投资，总投资逾1.2亿美元。上海证券大厦3600平方米的交易大厅，是目前亚太地区最大的无柱交易大厅，场内长32米、高4米的电子显示屏也称亚洲之最。`,
  t700: `武汉保利广场`,
  t701: `武汉保利广场为中国保利集团继北京保利大厦、北京新保利大厦、广州中信广场、上海证券大厦等建筑之后，在华中地区斥巨资打造的"同系力作"。位于武汉内环核心、华中金融城主轴、湖北省政治文化，傲据水果湖政务圈、中南商圈、东湖生态圈三大绝版区域黄金分割点，中心以211.8米的高度俯瞰武汉三镇。`,
  t702: `人居四感体系`,
  t703: `第1重价值坐标-美学质感`,
  t704: `从大空间到小细节，从表象到内里，全盘全维考究中，雕琢产品美学质感，跨越东西方的审美传承。`,
  t705: `第2重价值坐标-环境适感`,
  t706: `以低碳绿色建筑编织更绿色的城市生活，借助智慧科技力量打造居家场景，人性化的全场景筑底。`,
  t707: `第3重价值坐标-关系灵感`,
  t708: `从社区外缤纷烟火到社区内多元互动，在激发空间互动能量中，找到舒适愉悦的理想关系。`,
  t709: `第4重价值坐标-精神情感`,
  t710: `从关键触点守护、愉悦时光共鉴、高阶服务预设、幸福传递领创等维度，谱写致美 生活图谱。`,
  t711: `面对多元化美好诉求，保利置业以"甲第"、"誉"、"赋"、"印"、"壹号"五大产品系去回应，从城市到山海，覆盖国际与东方，这五条产品系共同谱写了保利置业的致美生活图谱,拓宽当代美好人居的丰盛图景，提供更为和谐的安居向往之地。`,
  t712: `点击放大`,
  t713: `稀贵显赫藏品`,
  t714: `耀世瞩目的尊贵象征`,
  t715: `苏州紫金·翡丽甲第`,
  t716: `中国保利集团& 金隅地产双钜合著,苏州首座"甲第"系作品，划界苏州豪宅新时代。择址湖东核心精粹金鸡湖 CBD 重量级资源配套，同源国际生活范式，承袭保利"甲第"系高端豪宅基因，融汇千年姑苏底蕴与世界审美,以世界级传奇酒店为灵感蓝本,境呈酒店式艺术奢雅园境。以穿越时间周期的璀璨藏品,致敬苏州塔尖圈层倾赏。`,
  t717: `上海保利·翡丽甲第`,
  t718: `上海保利·翡丽甲第：作为保利置业上海滨江豪宅封面之作，项目 2015 年底开盘销售,入市便受到了市场的青睐，并取得 2016 年杨浦区商品住房销冠，成为杨浦区豪宅典范。产品打造以东方居住哲学，融会西方建筑精粹;在室内空间的打造上，兼顾优雅与功能，通过对居家生态、智能体系、定制车位等多维度的精工雕琢,使得杨浦区新建商品住宅在文化人居体验上有了显著提升。`,
  t719: `高定艺术瑰品`,
  t720: `引领时代的高阶享受`,
  t721: `广州保利琅誉`,
  t722: `保利琅誉，保利置业打造的第九座「誉」字系高端产品，择址番禺区府新城，位于"番禺广场"与"番禺客运站"双TOD上，集高浓度、高品质的城市精粹为一体，交通便捷，番禺永旺梦乐城、基盛万科里等城市级商圈环伺，幼儿园就在家下，广外附小及仲元中学在侧；未来，居住于此，时刻感受生活的美好与丰盈。`,
  t723: `济南保利珑誉`,
  t724: `济南保利珑誉，约26万方大体量高端住宅项目，雄据CBD中环，观臻"山泉湖河城"城市天际线，近享茂岭山、绸带公园自然美景，集萃CBD万千繁华，优质商业、医疗、交通、教育等配套资源环伺。主城稀有绿建三星标准住宅，社区配置超1600㎡殿堂级会所，书写城市奢享人居范本。`,
  t725: `香港保利龙誉`,
  t726: `项目傲据香港启德发展区优越位置，前临启德邮轮码头及维多利亚港，迅步可达港铁启德站，穿梭港九新界，尽享未来落成沙中线交通优势及启德区生活之配套便利。尊尚住客会所「THEVIBE」设计简约时尚，总面积约3万5千平方，提供逾32项室内户外设施, 是香港启德九龙核心区盛誉之作。`,
  t727: `厚韵传著之作`,
  t728: `精粹的人文体验`,
  t729: `苏州保利尚云赋`,
  t730: `保利置业赋系首作，位于苏州昆山国际经开，在世界看东方的趋势之下，通过建筑、文化、圈层的赋新，赋写东方大国的文化自信。项目特邀大师团队,以低密隐奢为基础，人居四感体系为框架，构筑东方人文精奢大平墅。以纯粹圈层场域，为时代所序。感受自然，体验东方美学园林的深远意境和生活哲学。`,
  t731: `苏州保利珺华赋`,
  t732: `高端改善赋系第三子，落址苏州工业园区独墅湖高教区之上，高校环伺、智企汇聚；约2KM独墅湖边，五大生态公园环绕，集萃园区商业、教育、自然、人文等精华资源。以江南文化为底蕴，师法全球顶奢酒店安缦系，辅以全球臻材奢石，全冠移植黑松&羽毛枫等珍植，以高定私人会所为核心、匠筑约152-222㎡文化奢宅。`,
  t733: `济南保利鹊华赋`,
  t734: `高奢赋系济南首作，特邀五位国际设计大师合著，以约6000亩围子山半山为势，打造1.2容积率低密峯境，4-8层约165-240㎡浮岛洋房，4层约220-350㎡高定隐墅，社区内享万平青山景观，约1300㎡美学会所，呈映东方雅奢墅居。`,
  t735: `灵感心造之作`,
  t736: `宠悦自我的丰盛获得`,
  t737: `广州保利锦上印`,
  t738: `保利锦上印依托2条花地湾滨水景观资源,规划耗资千亿120万㎡东漖旧改项目"2+8"生态升级系统焕新城市面貌,配建约40万㎡公园式滨水商业群落,满足吃喝玩乐、娱乐休闲等需求。项目内规划约1.8万㎡"安缦系"园林,匠筑六大精奢空间,一馆十二泛会所,丰富业主圈层邻里生活,定义广府低密品质人居新标准。`,
  t739: `南宁保利宸上印`,
  t740: `项目位踞主城一环核心，秀厢大道中央，尽汇学铁商园全维优质资源，脉承"印"系高端产品基因，匠造主城难得约3.0低密舒居。在户型设计上享约100%得房率，高性价比入阶主城热土，是全国第五座印系著作。`,
  t741: `山水栖心之作`,
  t742: `自在归心的山海沉浸`,
  t743: `万宁保利·半岛壹号`,
  t744: `项目，保利置业的自然旅居杰作，择址海南万宁老爷海度假生活区。项目独揽内外双海资源，依托约1.6公里海岸线，采用山、居、岸、海的整体规划理念，打造完美视觉与海洋内涵的度假住区，创享多元沉浸式的度假体验。`,
  t745: `铸就高品质物业服务`,
  t746: `缔造全周期美好生活`,
  t747: `保利物业 美好服务`,
  t748: `上海保利物业酒店管理集团有限公司（以下简称保利物业）于1996年在北京成立，隶属于保利置业集团，作为首批国家一级资质物业，保利物业率先将星级酒店服务品质融入物业服务，致力为业主创造安全、舒适、温馨的人居环境。自1997年保利物业第一个大型涉外别墅项目北京丽京花园起，保利物业以日益精益的服务打造出上海翡丽甲第、上海证券大厦、广州中信广场、北京新保利大厦等标杆项目，见证着城市蓬勃发展的浪潮，截止2024年6月30日，进驻全国41个城市，服务321个项目，与近百万业主共创美好生活。`,
  t749: `旗下业务`,
  t750: `住宅`,
  t751: `商写`,
  t752: `城市`,
  t753: `多元`,
  t754: `住宅服务`,
  t755: `全时服务，深度关怀`,
  t756: `始终以业户的精细需求和全面尊重为核心`,
  t757: `浏览网站`,
  t758: `商写服务`,
  t759: `高标服务，高效管理`,
  t760: `至善服务，统一服务理念和价值观`,
  t761: `城市服务`,
  t762: `多元创新，个性定制`,
  t763: `因地制宜，因时施策，创新探索个性化服务产品`,
  t764: `多元服务`,
  t765: `多元引擎，全景生态`,
  t766: `围绕社区生活场景，聚焦客户全景生态服务需求`,
  t767: `个酒店`,
  t768: `保利商旅 邂逅美好`,
  t769: `保利商旅酒店管理有限公司是保利置业集团有限公司全资子公司，是融合酒店、商业、写字楼、健身等多业态、市场化、品牌化的酒店及商业资产管理公司，负责置业集团自营酒店项目的经营管理，外资酒店品牌的业主管理、部分商业及写字楼管理、健身房运营及新项目的开发等。`,
  t770: `目前，主业酒店板块已布局在全国8个城市共9家酒店，既有位于一线城市核心区的高端商务型酒店，也有位于城市周边的温泉酒店、景区酒店等项目。其中委托管理酒店项目4家分别与洲际酒店集团和凯悦酒店集团合作，分别是上海嘉定凯悦酒店、柳州凯悦嘉轩酒店、德清凯悦嘉轩酒店、顺德保利假日酒店；自营酒店5家，包括北京保利大厦酒店、湖北保利大酒店、贵阳保利国际温泉酒店、四川保利新九寨宾馆及四川华龙山庄等。`,
  t771: `旗下业务`,
  t772: `酒店`,
  t773: `健身`,
  t774: `商业`,
  t775: `负责置业集团自营酒店项目的经营管理、外资品牌的业主管理，`,
  t776: `在全国8座城市经营9家四星、五星酒店；`,
  t777: `浏览网站`,
  t778: `保利健身是保利商旅生活服务品牌，我们以央企的品质与责任为基础理念，`,
  t779: `为社区、家庭和个人打造高标准的健康休闲空间，传递保利品牌的`,
  t780: `服务理念、文化精神， 以及活力、勇敢与爱。`,
  t781: `商业部分包括商业写字楼的管理及房地产商业租赁，`,
  t782: `通过多年丰富的经验，引进海内外优质商业资源，盘活存量资源。`,
  t783: `暖意归家`,
  t784: `用最热情温暖的态度，迎接每一个来到保利酒店的客户，`,
  t785: `好像迎接家人归来一般。`,
  t786: `为客移驾 ｜ 盛迎佳客 ｜ 代持行李 ｜ 全程引导 ｜ 敬诚问候 ｜ 舒心办理`,
  t787: `心安无忧`,
  t788: `用最专业的服务满足客户的各方面基础需求，`,
  t789: `做到积极、专业、准确、及时服务。`,
  t790: `引客入居 ｜ 行李随行 ｜ 自报家门 ｜ 臻味上门 ｜ 佳肴品读`,
  t791: `舒适怡然`,
  t792: `从满足客户需求出发，各环节的高标准服务，`,
  t793: `为客户打造全方位的舒适体验。`,
  t794: `遇客喜相迎 ｜ 舒适浴感 ｜ 品质用品 ｜ 亲肤浴巾 ｜ 适宜体感 ｜ 宜人床品 ｜ 宜寝软榻`,
  t795: `美好可期`,
  t796: `保利商旅酒店的个性化的服务，提供超越期待的惊喜，`,
  t797: `为旅途留下更加美好的回忆。`,
  t798: `餐前问候 ｜ 敬请入座 ｜ 佳肴介绍 ｜ 高效结账 ｜ 用餐反馈 ｜ 办理离店 ｜ 体验反馈 ｜ 送客礼仪`,
  t799: `吾乡有情`,
  t800: `我们不止关心我们的客人，更关心社会的福祉，关心自然。`,
  t801: `时刻肩负作为一个央企品牌的社会责任。`,
  t802: `保利酒店酒店长期致力于社区建设、特殊人群关爱、环境保护和可持续发展，为社会美好发展贡献自己的力量。`,
  t803: `小保的诞生`,
  t804: `小保大事记`,
  t805: `小保乐园`,
  t806: `小保绘本`,
  t807: `小保文创小宇宙`,
  t808: `品牌体系`,
  t809: `品牌IP`,
  t810: `责任品牌`,
  t811: `保利置业始终坚持"保利是吾乡"品牌愿景，以"心安吾乡"为品牌主张，以人本主义为精神内核，以产品主义为硬核实力，以专业主义为重要抓手，始终坚持长期主义为发展导向，以"至真、致美、置吾乡"为客户宣言，通过产品、服务、文化、责任四大品牌建设触点，提升市场化品牌影响力，聚焦"品质五力"、"服务五心"核心竞争力，打造具有卓越竞争力的品牌生态链，为广大客户和业主兑现美好期许。`,
  t813: `小保的诞生`,
  t814: `小保大视界`,
  t815: `小保乐园`,
  t816: `小保绘本`,
  t817: `小保元宇宙`,
  t818: `品牌体系`,
  t819: `品牌IP`,
  t820: `责任品牌`,
  t821: `我的岗位`,
  t822: `中国保利集团 | 首席美好狮`,
  t823: `我的星座`,
  t824: `狮子座`,
  t825: `我的性格`,
  t826: `乐观阳光 自信果敢 社交达人`,
  t827: `我的告白`,
  t828: `你是我的保`,
  t829: `我的超能力`,
  t830: `外貌：`,
  t831: `化身美好之狮，象征力量与无畏担当`,
  t832: `头发：`,
  t833: `身披火焰，用卓越之心点亮世间美好`,
  t834: `眼镜：`,
  t835: `头戴四次元眼镜，发现美好探索时空`,
  t836: `尾焰：`,
  t837: `燃烧的星火，赋予魔法棒的改变之力`,
  t838: `美好吾乡 一起出发`,
  t839: `2024怀揣"保利是吾乡"的品牌愿景`,
  t840: `小保与你一同卓越前行`,
  t841: `是我全新的品牌主张`,
  t842: `担纲央企责任，保有美好之心`,
  t843: `我们不断践行运营城市美好的方方面面`,
  t844: `致力于打造吾心安处的幸福空间和心灵归属`,
  t845: `成长的陪伴 生活的乐园`,
  t846: `在每一个孩子心中`,
  t847: `几乎都有一个像孙悟空…奥特曼一样的超级偶像存在`,
  t848: `不仅是孩子们成长时光中的陪伴者`,
  t849: `更成为深刻影响他们成长的精神力量`,
  t850: `我们希望`,
  t851: `小保能够为孩子们的成长注入光的力量`,
  t852: `让每一天都充满惊喜`,
  t853: `为孩子们打造专属的成长乐园`,
  t854: `小保童行 共绘美好`,
  t855: `绘本，作为孩子"人生中的第一本书"，`,
  t856: `正逐渐发展成全民刚需、高频使用的亲子陪伴场景，`,
  t857: `并成为家庭教育的标配。`,
  t858: `我们将中国优秀传统文化融入原创儿童绘本，`,
  t859: `打造"小保绘本"专属系列，`,
  t860: `助力培养孩子的世界观和学习观，`,
  t861: `树立民族自信心、提升民族自豪感。`,
  t862: `为保利业主家庭，带来更美好的陪伴。`,
  t863: `多元美好 探索无限`,
  t864: `这是一个拥抱无限可能的平台，`,
  t865: `打造情感的超级社群？创造智慧的科技未来？`,
  t866: `搭建艺文的交流平台？智造文创的丰富周边？`,
  t867: `小保愿与大家携手共创美好吾乡！`,
  t868: `关于我们`,
  t869: `向新保利 美好生活的领创者`,
  t870: `蓬勃保利 务实笃行的奋斗者`,
  t871: `商旅保利 星级酒店的铸筑者`,
  t872: `责任保利 乡村振兴的践行者`,
  t873: `匠心保利 城市地标的建造者`,
  t874: `家国保利 国宝兽首的守护者`,
  t875: `创新保利 高新科技的探索者`,
  t876: `美好保利 社区治理的耕耘者`,
  t877: `时代保利 国家开放的见证者`,
  t878: `保国利民 国资在港的担当者`,
  t879: `保利置业的诞生、成长与壮大，与国家战略发展紧密相连。1993年，中国保利集团完成香港上市公司新海康航业投资有限公司(H.K. 00119) 55%的股权收购，实现在港主板上市。保利（香港）控股先后参与广州中信广场、北京新保利大厦等项目开发建设，布局香港龙誉、瑧誉、沄璟等多个行业标杆，累计在港创造数千个岗位，服务近千个家庭。`,
  t880: `领潮保利 时代人居的助推者`,
  t881: `1992年，中国保利集团取得第一张涉外国有土地使用证（京中外国用（92）字第0001号）。这份土地证见证了丽京花园项目从筹建、选址、立项、施工，到销售、物业管理的每一个环节。作为北京市第一个涉外商品房项目，也是中国保利集团第一个房地产项目，在内地和香港两地同时销售的丽京花园，吸引大量华侨、港澳台同胞购买定居，创下了"4小时销售60套"的保利传奇。第一张涉外国有土地使用证，亲鉴一代代保利人进取的奋斗史，成为保利人奋进的精神力量。`,
  t882: `四十有为`,
  t885: `© 2024 中国保利集团 版权所有。`,
  t886: `沪ICP备09090711号-2`,
  t887: `沪公网安备 31011502015790号`,
  t888: `首页`,
  t889: `关于我们`,
  t890: `中国保利集团`,
  t892: `组织架构`,
  t893: `品牌文化`,
  t894: `发展历程`,
  t895: `新闻动态`,
  t899: `多元业务`,
  t900: `房地产开发`,
  t901: `物业服务`,
  t902: `商旅服务`,
  t903: `科技创新`,
  t912: `可持续发展`,
  t922: `联系我们`,
  t923: `（主席）`,
  t924: `香港`,
  t925: `业务领域`,
  t926: `测速中`,
  t927: `延迟`,
  t928: `请选择适合您的线路`,
  t929: `欢迎访问`,
}
